var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge mr-1 pl-0 enterprise"},[_c('font-awesome-icon',{attrs:{"icon":"building"}}),_vm._v(" "+_vm._s(_vm.extractEnterprise()))],1)}
var staticRenderFns = []

export { render, staticRenderFns }